import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import '../styles/Navbar.css';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <span className="dev-name">Julián Calle</span>
        </Link>
        
        <div className="menu-icon" onClick={toggleMenu}>
          <FontAwesomeIcon icon={menuOpen ? faTimes : faBars} />
        </div>
        
        <ul className={menuOpen ? 'nav-menu active' : 'nav-menu'}>
          <li className="nav-item">
            <Link to="/" className="nav-link" onClick={() => setMenuOpen(false)}>
              Inicio
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/sobre-mi" className="nav-link" onClick={() => setMenuOpen(false)}>
              Sobre Mí
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/trayectoria" className="nav-link" onClick={() => setMenuOpen(false)}>
              Trayectoria Profesional
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/habilidades" className="nav-link" onClick={() => setMenuOpen(false)}>
              Habilidades
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/contacto" className="nav-link" onClick={() => setMenuOpen(false)}>
              Contacto
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar; 